<template>
  <div class="pagination">
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="selectPage"
    />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: null,
    },
  },
  methods: {
    selectPage(page) {
      this.$emit("changePage", page);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.pagination {
  .el-pager {
    li {
      font-size: 1.6rem;
      font-weight: 600;
      color: $text_gray;
      &:hover,
      &.active {
        color: $accentBlue;
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    padding: 0;

    button {
      background-color: $accentBlue;
      color: $white;
      padding: 0;
      height: 3.4rem;
      width: 3.4rem;
      min-width: 3.4rem;

      &:hover {
        color: $white;
        opacity: 0.7;
      }
    }

    .btn-next {
      padding-left: 0;
      position: relative;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 3.4rem solid $accentBlue;
        border-right: 1.3rem solid transparent;
        right: -1.3rem;
        top: 0;
        bottom: 0;
      }
    }

    .btn-prev {
      padding-right: 0;
      position: relative;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 3.4rem solid $accentBlue;
        border-left: 1.3rem solid transparent;
        left: -1.3rem;
        top: 0;
        bottom: 0;
      }
    }
  }
}

.el-icon-arrow-left, .el-icon-arrow-right {
  color: $white;
}
</style>
